import { useEffect, useState } from "react";
import api, { money, shortDate } from "@/lib/api";
import { Card, PageHeader, EmptyState, Badge } from "@/components/kit";

export default function CollectionsPage() {
  const [collections, setCollections] = useState([]);
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    (async () => {
      const [a, c] = await Promise.all([
        api.get("/collections?limit=200"),
        api.get("/customers"),
      ]);
      setCollections(a.data);
      setCustomers(c.data);
    })().catch(() => {});
  }, []);

  const custName = (id) => customers.find((c) => c.id === id)?.name || "—";

  return (
    <div className="w-full p-4 md:p-8 pb-24 md:pb-8 fade-up">
      <PageHeader title="Collections" subtitle="All field & counter collections with receipt numbers." />
      <Card>
        {collections.length === 0 ? (
          <EmptyState title="No collections recorded" />
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
                <tr>
                  <th className="text-left px-4 py-3 font-semibold">Receipt</th>
                  <th className="text-left px-4 py-3 font-semibold">Date</th>
                  <th className="text-left px-4 py-3 font-semibold">Customer</th>
                  <th className="text-left px-4 py-3 font-semibold">Kind</th>
                  <th className="text-right px-4 py-3 font-semibold">Amount</th>
                </tr>
              </thead>
              <tbody>
                {collections.map((c) => (
                  <tr key={c.id} className="border-t border-slate-100 hover:bg-slate-50" data-testid={`coll-row-${c.id}`}>
                    <td className="px-4 py-3 mono">{c.receipt_no}</td>
                    <td className="px-4 py-3 text-slate-600">{shortDate(c.created_at)}</td>
                    <td className="px-4 py-3 font-medium">{custName(c.customer_id)}</td>
                    <td className="px-4 py-3">
                      <Badge tone={c.kind === "loan_repayment" ? "info" : "success"}>
                        {c.kind === "loan_repayment" ? "Loan repayment" : "Savings deposit"}
                      </Badge>
                    </td>
                    <td className="px-4 py-3 mono text-right font-medium text-emerald-700">{money(c.amount)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
